import { PaymentDueBanner as SharedPaymentDueBanner } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const NoLicenceBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SharedPaymentDueBanner
      title={t("banner.noLicence.title")}
      subtitle={t("banner.noLicence.subtitle")}
      ctaLabel={t("banner.noLicence.cta")}
      onCtaClick={() => navigate("/manager/licence")}
    />
  );
};
